import { Box, Button, Chip, Divider, FormControl, Grid, InputLabel, ListItem, Popover, Skeleton, Stack, Typography } from '@mui/material';
import React, { Fragment, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '../../store/store';
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ClearAllIcon from '@mui/icons-material/ClearAll';
import { storeUserLocationDetailsMutationThunk } from '../../store/thunk/tenantThunk';
import { Avatar } from '@mui/material';
//F=Facility,FU=Facility group, L=Floor,R=Room, U=Unit
type Props = {
    startLevel?: Locations;
    endLevel?: Locations;
    handleSelection: (value?: HandleSelectionReturnType) => void;
    initialValue?: HandleSelectionReturnType;
}
const LocationSelector = ({ startLevel = Locations.system, endLevel = Locations.device, handleSelection, initialValue }: Props) => {
    const locations = useAppSelector((store) => (store?.locationSlice?.locationList?.getLocations || []) as LocationListType[]);
    const locationLoader = useAppSelector((store) => store?.locationSlice?.loading);
    const tenantLoader = useAppSelector((store) => store?.tenantSlice?.loading);
    const configuredDevices = useAppSelector((store) => (store?.deviceSlice?.configureListNew || []) as DeviceInfoType[]);
    const allDevice = useAppSelector((store) => store?.deviceSlice?.deviceList);
    console.log("configuredDevices ::", configuredDevices);

    const [currentSelector, setCurrentSelector] = useState<keyof typeof LocationSelectorTypes>(startLevel || Locations.system);
    const [options, setOptions] = useState<LocationListType[] | DeviceInfoType[]>([]);
    const [facilityGroupOptions, setFacilityGroupOptions] = useState<LocationListType[]>([]);
    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
    const [selectedValues, setSelectedValues] = useState<SelectedValueType>();
    const [confirmSelectedValues, setConfirmSelectedValues] = useState<SelectedValueType>();
    const [deviceData, setDeviceData] = useState<DeviceInfoType[]>([]);
    const [isFacilityGroup, setIsFacilityGroup] = useState<boolean>(false);
    const [isUnit, setIsUnit] = useState<boolean>(false);
    const userData = useAppSelector((store) => store?.authReducer?.userData);
    const dispatch = useAppDispatch();
    const [loader, setLoader] = useState(true);
    useEffect(() => {
        setLoader(locationLoader || tenantLoader);
    }, [locationLoader, tenantLoader]);
    useEffect(() => {
        const locationData = ((!selectedValues && !!initialValue) ? initialValue : JSON.parse(userData?.location_info || "{}")) as userLocationInfoType;
        if (!!locationData && locations?.length > 0) {
            const system = locations.find((i) => i?.key === locationData?.system);
            const facility = locations.find((i) => i?.key === locationData?.facility);
            const floor = locations.find((i) => i?.key === locationData?.floor);
            const room = locations.find((i) => i?.key === locationData?.room);
            let tempSelectedValue: SelectedValueType = {};
            tempSelectedValue = {
                ...((system && startLevel <= Locations.system && endLevel >= Locations.system) ? { [Locations.system]: { name: system?.name, value: system?.key, type: system?.type } } : {}),
                ...((facility && startLevel <= Locations.facility && endLevel >= Locations.facility) ? { [Locations.facility]: { name: facility?.name, value: facility?.key, type: facility?.type } } : {}),
                ...((floor && startLevel <= Locations.floor && endLevel >= Locations.floor) ? { [Locations.floor]: { name: floor?.name, value: floor?.key, type: floor?.type } } : {}),
                ...((room && startLevel <= Locations.room && endLevel >= Locations.room) ? { [Locations.room]: { name: room?.name, value: room?.key, type: room?.type } } : {}),
            }
            const data = {
                system: tempSelectedValue?.[Locations.system],
                facility: tempSelectedValue?.[Locations.facility],
                floor: tempSelectedValue?.[Locations.floor],
                room: tempSelectedValue?.[Locations.room],
                device: tempSelectedValue?.[Locations.device],
            }
            setSelectedValues(tempSelectedValue);
            setConfirmSelectedValues(tempSelectedValue);
            handleSelection(data);
            const facilityGroup = facility?.type === "FU";
            const isUnit = !!floor?.is_unit;
            setIsUnit(isUnit)
            setIsFacilityGroup(facilityGroup)
            const locationLevels = [
                endLevel,
                Locations.device,
                Locations.room,
                Locations.floor,
                Locations.facility,
                Locations.system,
            ];

            let tempCurrentLevel = startLevel || Locations.system;
            for (const level of locationLevels) {
                if (tempSelectedValue?.[level]) {
                    tempCurrentLevel = [Locations.device, endLevel]?.includes(level) ? level : ((facility?.type === "FU" && Locations.facility === level) ? level + 2 : level + 1); // to skip a floor we increase with 2 when facility is group
                    break;
                }
            }
            // let tempCurrentLevel = Locations.device;
            // if (tempSelectedValue?.[endLevel]) {
            //     tempCurrentLevel = endLevel;
            // } else if (tempSelectedValue?.[Locations?.device]) {
            //     tempCurrentLevel = Locations?.device;
            // } else if (tempSelectedValue?.[Locations?.room]) {
            //     tempCurrentLevel = Locations?.room + 1;
            // } else if (tempSelectedValue?.[Locations?.floor]) {
            //     tempCurrentLevel = Locations?.floor + 1;
            // } else if (tempSelectedValue?.[Locations?.facility]) {
            //     tempCurrentLevel = Locations?.facility + 1;
            // } else if (tempSelectedValue?.[Locations?.system]) {
            //     tempCurrentLevel = Locations?.system + 1;
            // }
            setCurrentSelector(tempCurrentLevel)
        } else {
            setSelectedValues(undefined);
            setConfirmSelectedValues(undefined);
            handleSelection({});
        }
    }, [userData?.location_info, JSON.stringify(locations), JSON.stringify(initialValue)]);
    useEffect(() => {
        if (allDevice?.data?.length > 0 && configuredDevices?.length > 0) {
            setDeviceData(() => {
                return configuredDevices?.filter((value) => !!value?.loc)?.map((value) => {
                    const device = allDevice?.data?.find((device: any) => value?.pk?.includes(device?.id));
                    return {
                        ...value,
                        name: device?.attributes?.name || "",
                        key: device?.id,
                        type: "device"
                    }
                });
            })
        }
    }, [JSON.stringify(allDevice), JSON.stringify(configuredDevices)]);

    // console.log(options, facilityGroupOptions, currentSelector, selectedValues, deviceData, confirmSelectedValues, 'options');
    useEffect(() => {
        let data: LocationListType[] | DeviceInfoType[] = [];
        if (currentSelector === Locations.device) {
            data = deviceData?.filter((value) => (!selectedValues?.[Locations.room]?.value || selectedValues?.[Locations.room]?.value === value?.loc));
        } else {
            data = locations?.filter((value) => {
                const levelNumber = isFacilityGroup && Locations.room == currentSelector ? 2 : 1
                const tmpLocation = (currentSelector - levelNumber) as keyof typeof LocationSelectorTypes;
                return (
                    (!selectedValues?.[tmpLocation]?.value && LocationSelectorTypes?.[currentSelector]?.value?.includes(value?.type))
                    ||
                    (selectedValues?.[tmpLocation]?.value === value?.parentKey && LocationSelectorTypes?.[currentSelector]?.value === value?.type)
                )
            });
            if (Locations.facility == currentSelector) {
                const groupOptions = locations?.filter((value) => {
                    const tmpLocation = (currentSelector - 1) as keyof typeof LocationSelectorTypes;
                    return (
                        (!selectedValues?.[tmpLocation]?.value && ["FU"]?.includes(value?.type))
                        ||
                        (selectedValues?.[tmpLocation]?.value === value?.parentKey && ["FU"]?.includes(value?.type))
                    )
                });
                setFacilityGroupOptions(groupOptions);
            } else {
                setFacilityGroupOptions([]);
            }
        }
        setOptions(data);
    }, [currentSelector, selectedValues, deviceData, JSON.stringify(locations), isFacilityGroup]);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {

        if (JSON.stringify(selectedValues) !== JSON.stringify(confirmSelectedValues)) {
            setCurrentSelector(startLevel);
        }
        setAnchorEl(null);
        setSelectedValues(confirmSelectedValues);
    };
    const selectLocationHandler = (option: LocationListType | DeviceInfoType, levelIncrease = 1) => {
        if (Locations.facility == currentSelector) {
            setIsFacilityGroup(option?.type === "FU");
        }
        if (Locations.floor == currentSelector) {
            setIsUnit(!!option?.is_unit);
        }
        setSelectedValues((prev) => {
            return {
                ...prev,
                [currentSelector]: { name: option?.name, value: option?.key, type: option?.type },
            }
        });
        if (currentSelector < endLevel)
            setCurrentSelector(prev => ((+prev) + levelIncrease) as keyof typeof LocationSelectorTypes);
    }
    const changeCurrentSelectorHandler = (select: Locations) => {
        setCurrentSelector(select);
        const data = filterByMaxKey((selectedValues || {}), select)
        setSelectedValues(data);
    }
    const getSelectedLocations = () => {
        let selected: string[] = [];
        Object.keys(confirmSelectedValues || {})?.map((key: unknown, index) => {
            const typedKey = key as keyof typeof LocationSelectorTypes;
            const name = confirmSelectedValues?.[typedKey]?.name
            if (name)
                selected = [...selected, name || ""]
        })
        return selected.join(" > ");
    }
    const saveLocationSelectorValue = () => {
        const data = {
            system: selectedValues?.[Locations.system],
            facility: selectedValues?.[Locations.facility],
            floor: selectedValues?.[Locations.floor],
            room: selectedValues?.[Locations.room],
            device: selectedValues?.[Locations.device],
        };
        handleSelection(data);
        setConfirmSelectedValues(selectedValues);
        handleClose();
        const requestLocationInfo = {
            system: selectedValues?.[Locations.system]?.value,
            facility: selectedValues?.[Locations.facility]?.value,
            floor: selectedValues?.[Locations.floor]?.value,
            room: selectedValues?.[Locations.room]?.value,
            device: selectedValues?.[Locations.device]?.value,
            isFacilityGroup,
            isUnit: isUnit
        }
        dispatch(storeUserLocationDetailsMutationThunk({ username: userData?.username, location_info: requestLocationInfo }))
    }

    const getMatchingDevices = (rooms: any[], devices: any[]): any[] => {
        const roomKeys = new Set(rooms.map((room) => room.key));
        return devices.filter((device) => roomKeys.has(device.loc));
    };



    const getDeviceIcon = (option: any): React.ReactElement | undefined => {
        const facility = selectedValues?.[Locations.facility];
        if (!facility) return undefined;

        const isFacilityFU = facility.type === "FU";
        const allData = Array.isArray(locations) ? locations : [];
        const devices = Array.isArray(configuredDevices) ? configuredDevices : [];

        let facilityDevices: any[] = [];
        let floors: any[] = [];

        if (isFacilityFU) {
            const roomsData = locations?.filter((value) => {
                const levelNumber = isFacilityGroup && Locations.room == currentSelector ? 2 : 1
                const tmpLocation = (currentSelector - levelNumber) as keyof typeof LocationSelectorTypes;
                return (
                    (!selectedValues?.[tmpLocation]?.value && LocationSelectorTypes?.[currentSelector]?.value?.includes(value?.type))
                    ||
                    (selectedValues?.[tmpLocation]?.value === value?.parentKey && LocationSelectorTypes?.[currentSelector]?.value === value?.type)
                )
            });
            facilityDevices = getMatchingDevices(roomsData, devices);
            floors = allData.filter(
                (item) => item.type === "FU" && item.key === facility?.value
            );
        } else {
            facilityDevices = devices.filter((item) => item.fcl === facility?.value);
            floors = allData.filter(
                (item) => item.type === "L" && item.parentKey === facility?.value
            );
        }

        // Get all rooms from the data
        const roomsData = allData.filter((item) => item.type === "R");

        // Map each floor to include its rooms and device flags
        const floorsWithRooms = floors.map((floor) => {
            const associatedRooms = roomsData
                .filter((room) => room.parentKey === floor.key)
                .map((room) => {
                    const roomDevices: any = isFacilityFU
                        ? facilityDevices.filter((device) => device.loc === room.key)
                        : floor.is_unit
                            ? facilityDevices.filter((device) => device.loc === room.key)
                            : facilityDevices.filter(
                                (device) => device.flr === floor.key && device.loc === room.key
                            );

                    const devicesMapped = roomDevices.map((device: any) => ({
                        name: device.location_name?.trim() || "",
                        providerId: device?.providerId || "",
                        deviceId: device.pk?.split("|")[1] || "",
                    }));

                    return {
                        ...room,
                        devices: devicesMapped,
                        thirdPartyDevice: devicesMapped.some(
                            (device: any) => device.providerId.trim() !== ""
                        ),
                        ieqDevice: devicesMapped.some(
                            (device: any) => device.providerId.trim() === ""
                        ),
                        statusCount: roomDevices.length,
                    };
                });

            return {
                ...floor,
                value: floor.key,
                name: floor.name,
                isUnit: floor.is_unit,
                type: floor.type,
                rooms: associatedRooms,
                thirdPartyDevice:
                    associatedRooms.length > 0 &&
                    associatedRooms.every((room) => room.thirdPartyDevice),
                ieqDevice:
                    associatedRooms.length > 0 &&
                    associatedRooms.every((room) => room.ieqDevice),
            };
        });

        if (selectedValues?.[Locations.floor] || facility?.type === "FU") {
            // const selectedFloor = selectedValues[Locations.floor];

            let matchingFloor: any = [];

            if (isFacilityFU) {
                const selectedFacility = selectedValues[Locations.facility];
                matchingFloor = floorsWithRooms.find(
                    (floor) => selectedFacility?.value === floor.value
                );

            } else {

                const selectedFloor = selectedValues[Locations.floor];
                matchingFloor = floorsWithRooms.find(
                    (floor) => selectedFloor?.value === floor.key
                );
            }

            const matchingRoom = matchingFloor?.rooms.find(
                (room: any) => room.key === option?.key
            );

            return (
                <Avatar
                    sx={{
                        backgroundColor: "transparent",
                        width: "auto",
                        height: "auto",
                        paddingX: 0.5,
                        paddingY: 0.2,
                        borderRadius: 2
                    }}
                >
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                        {matchingRoom?.thirdPartyDevice && (
                            <img
                                src="/assets/images/Verkada.png"
                                width={24}
                                height={24}
                                alt="Verkada"
                                style={{ objectFit: "contain" }}
                            />
                        )}
                        {matchingRoom?.ieqDevice && matchingRoom?.thirdPartyDevice && (
                            <span style={{ fontSize: 14, color: "#999" }}>|</span>
                        )}
                        {matchingRoom?.ieqDevice && (
                            <img
                                src="/assets/images/ieqDevice.png"
                                width={24}
                                height={24}
                                alt="IEQ"
                                style={{ objectFit: "contain" }}
                            />
                        )}
                    </Stack>
                </Avatar>
            );
        };
    }



    return (
        <FormControl className='button-input-textfield' fullWidth>
            <InputLabel id="demo-simple-select-label" shrink>
                Locations
            </InputLabel>
            <Button
                fullWidth
                id="demo-customized-button"
                aria-haspopup="true"
                variant="outlined"
                disableElevation
                onClick={handleClick}
                endIcon={<KeyboardArrowDownIcon />}
                sx={{
                    height: "37px",
                    padding: "12px 22px",
                    alignItems: "center",
                    borderRadius: "5px !important",
                    border: "2px solid #E4E4E4",
                    lineHeight: "18.4px",
                    letterSpacing: "0.322px",
                }}
            >
                {Object.keys(confirmSelectedValues || {})?.length > 0 ?
                    <span style={{
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                        flex: 1,
                    }}>{getSelectedLocations()}</span>
                    : "Select Location"}
            </Button>
            <Popover
                id={!!anchorEl ? "custom-popover" : undefined}
                open={!!anchorEl}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "left",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "left",
                }}
            >
                <Box sx={{
                    "& > :not(style)": {
                        m: 1,
                        width: "30em",
                        borderRadius: "10px",
                    },
                }}>

                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, position: "relative", marginRight: "20px" }}>
                        {Object.keys(selectedValues || {})?.map((key: unknown, index, array) => {
                            const typedKey = key as Locations;
                            if (typedKey == endLevel) return;
                            return (
                                <Fragment key={index}>
                                    {(index !== 0) ? ">" : ""}
                                    <Typography onClick={() => {
                                        changeCurrentSelectorHandler(typedKey);
                                        // setCurrentSelector(typedKey);
                                        // const data = filterByMaxKey((selectedValues || {}), typedKey)
                                        // setSelectedValues(data);
                                    }} sx={{ color: "#678eda", cursor: "pointer", ":hover": { textDecoration: "underline" } }} variant="body1" key={index}>{selectedValues?.[typedKey]?.name}</Typography>
                                </Fragment>
                            )
                        })}
                        {(Object.keys(selectedValues || {})?.length > 0 && startLevel !== endLevel) ? ">" : ""}<Typography variant="body1" >{LocationSelectorTypes?.[currentSelector]?.name}</Typography>
                        <Box title={"Clear All"} sx={{ right: 2, position: 'absolute', cursor: "pointer" }} onClick={() => {
                            changeCurrentSelectorHandler(startLevel || Locations?.system);
                        }}>
                            <Button size='small' variant='outlined' color='warning'>Clear</Button>
                        </Box>
                    </Box>
                    <Divider />
                    <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {!loader &&
                            options?.map((option, index) => {
                                const deviceIcon =
                                    (currentSelector === Locations.room || option?.type === "FU") &&
                                    getDeviceIcon(option);
                                return (
                                    <Chip
                                        key={index}
                                        avatar={undefined} // disable default avatar prop
                                        label={
                                            <Box
                                                sx={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "space-between",
                                                    width: "100%",
                                                }}
                                            >
                                                <Box
                                                    sx={{
                                                        overflow: "hidden",
                                                        textOverflow: "ellipsis",
                                                        whiteSpace: "nowrap",
                                                        pr: deviceIcon ? 1 : 0, // add right padding only if there is an icon
                                                    }}
                                                >
                                                    {option?.name}
                                                </Box>
                                                {deviceIcon && (
                                                    <Box sx={{ display: "flex", alignItems: "center", ml: 1 }}>
                                                        {deviceIcon}
                                                    </Box>
                                                )}
                                            </Box>
                                        }
                                        variant={
                                            selectedValues?.[currentSelector]?.value === option?.key
                                                ? "filled"
                                                : "outlined"
                                        }
                                        sx={{
                                            cursor: "pointer",
                                            fontSize: 12,
                                            height: "auto",
                                            // minWidth: 120,
                                            maxWidth: 240,
                                            paddingY: 0.75,
                                            paddingX: 1,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                        onClick={() => selectLocationHandler(option)}
                                    />
                                );
                            })}
                        {!loader &&
                            options?.length <= 0 &&
                            facilityGroupOptions?.length <= 0 && (
                                <Typography
                                    variant="body1"
                                    sx={{ width: "100%", textAlign: "center" }}
                                >
                                    No records available.
                                </Typography>
                            )}
                    </Box>

                    {!loader && facilityGroupOptions?.length > 0 &&
                        <>
                            <Typography variant="body1">Groups</Typography>
                            <Divider />
                            <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                                {facilityGroupOptions?.map((option, index) => {
                                    return (
                                        <Chip key={index} label={option?.name} variant={selectedValues?.[currentSelector]?.value === option?.key ? "filled" : "outlined"} sx={{ cursor: "pointer" }} onClick={() => {
                                            setIsFacilityGroup(true);
                                            selectLocationHandler(option, 2)
                                        }} />
                                    );
                                })}
                            </Box>
                        </>
                    }
                    <Box sx={{ display: "flex", gap: 0.5 }}>
                        {(loader) && [...new Array(4)].map((value, index) => {
                            return (
                                <Skeleton sx={{ borderRadius: "15px" }} height={"45px"} width={"70px"} />
                            )
                        })}
                    </Box>
                </Box>
                <ListItem>
                    <Grid container alignItems="center" direction="column">
                        <Button
                            fullWidth
                            variant="contained"
                            onClick={saveLocationSelectorValue}
                        >
                            Done
                        </Button>
                    </Grid>
                </ListItem>
            </Popover >
        </FormControl>
    );
}

export default LocationSelector;

function filterByMaxKey<T extends Record<string, any>>(data: T, maxKey: number): T {
    return Object.fromEntries(
        Object.entries(data)
            .filter(([key]) => Number(key) < maxKey)
    ) as T;
}

export enum Locations {
    system = 1,
    facility = 2,
    floor = 3,
    room = 4,
    device = 5,
}

export const LocationSelectorTypes = {
    [Locations.system]: {
        name: "Systems",
        value: "S",
    },
    [Locations.facility]: {
        name: "Facilities",
        value: "F",
    },
    [Locations.floor]: {
        name: "Floors",
        value: "L",
    },
    [Locations.room]: {
        name: "Rooms",
        value: "R",
    },
    [Locations.device]: {
        name: "Devices",
        value: "D",
    },
}

type SelectedValueType = Partial<Record<keyof typeof LocationSelectorTypes, { name: string, value: string, type: string }>>
export type LocationListType = {
    key: string;
    parentKey: string;
    name: string;
    type: string;
    short_code: string;
    created_at: string; // ISO 8601 date string
    updated_at: string; // ISO 8601 date string
    is_deleted: boolean;
    is_region: boolean;
    is_unit: boolean;
    unit_key: string;
    space_id: string;
    facility_unit_key: string;
    locationName: string | null;
    floor_key: string | null;
};

export type DeviceInfoType = {
    fcl: string;
    flr: string;
    loc: string;
    stm: string;
    uni: string;
    pk: string;
    sk: string;
    location_name: string;
    tenantCode: string;
    created_at: string;
    updated_at: string;
    deviceImage: string;
    deviceImageUrl: string;
    name?: string;
    key?: string;
    type?: string;
    is_unit: false;
};

export type HandleSelectionReturnType = {
    system?: OptionType
    facility?: OptionType
    floor?: OptionType
    room?: OptionType
    device?: OptionType
}

type OptionType = { name: string; value: string; type: string; }
export type userLocationInfoType = {
    system?: string
    facility?: string
    floor?: string
    room?: string
    device?: string
}

